var React = require('react');

function Portal (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"PORTAL_w","data-name":"PORTAL w","transform":"translate(4040 -5772)"},React.createElement("g",{"id":"PORTAL_ikona","data-name":"PORTAL ikona","transform":"translate(0 -3.5)"},[React.createElement("circle",{"id":"Ellipse_19","data-name":"Ellipse 19","cx":"2.88","cy":"2.88","r":"2.88","transform":"translate(-4029.38 5781.5)","fill":"none","stroke":"#2f2e2e","strokeLinecap":"round","strokeWidth":"1","key":0}),React.createElement("path",{"id":"Rectangle_482","data-name":"Rectangle 482","d":"M4,0H8a4,4,0,0,1,4,4v.912a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V4A4,4,0,0,1,4,0Z","transform":"translate(-4032.5 5788.988)","fill":"none","stroke":"#2f2e2e","strokeLinecap":"round","strokeWidth":"1","key":1})])));
}

Portal.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27"};

module.exports = Portal;

Portal.default = Portal;
